import React, { useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Divider, IconButton } from 'rsuite';
import styled from 'styled-components';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Wrapper = styled.div`
  height: 66px;
  padding-left: 30px;
  padding-right: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
`;

const StyledButton = styled(Button)`
  width: 85px;
`;

function CaseIdDisplay({ caseId }) {
  return <div>Case Id: {caseId}</div>;
}

function Paginator({ nextPage, previousPage, currentPage, numPages }) {
  return (
    <div css="display: flex; justify-content: space-between; align-items: center;">
      <IconButton
        appearance="subtle"
        icon={<FaChevronLeft />}
        onClick={previousPage}
      />
      <div css="margin-left: 40px; margin-right: 40px;">
        {currentPage} of {numPages}
      </div>
      <IconButton
        appearance="subtle"
        icon={<FaChevronRight />}
        onClick={nextPage}
      />
    </div>
  );
}

const CancelButton = styled(StyledButton)`
  color: #101938;
`;

const PrintButton = styled(StyledButton)`
  margin-left: 13px;
`;

function ActionButtons(props) {
  const { onCancelClick, onBeforePrint, onAfterPrint, printContentRef } = props;

  const [loading, setLoading] = useState(false);

  const onClick = useReactToPrint({
    suppressErrors: true,
    content: () => printContentRef.current,
    onBeforePrint: () => {
      setLoading(true);
      onBeforePrint();
    },
    onAfterPrint: () => {
      setLoading(false);
      onAfterPrint();
    },
  });

  return (
    <div>
      <CancelButton appearance="subtle" onClick={onCancelClick}>
        Cancel
      </CancelButton>
      <PrintButton appearance="primary" loading={loading} onClick={onClick}>
        Print
      </PrintButton>
    </div>
  );
}

export function CitationPDFViewerHeader(props) {
  return (
    <>
      <Wrapper>
        <CaseIdDisplay caseId="CE=2018-1511" />

        <Paginator
          nextPage={props.nextPage}
          previousPage={props.previousPage}
          currentPage={props.currentPage}
          numPages={props.numPages}
        />

        <ActionButtons
          onCancelClick={props.onCancelClick}
          onBeforePrint={props.onBeforePrint}
          onAfterPrint={props.onAfterPrint}
          printContentRef={props.printContentRef}
        />
      </Wrapper>
      <Divider css="margin: 0;" />
    </>
  );
}
